export class PaymentOption {
    public imgPath: string;
    public instrumentNumber: string;
    public paymentMethod: string;
    public paymentText: string;
    public sportsOnly: boolean;
    public bankAccountsOnly: boolean;
    public isESRiskPlayer: boolean;
    public ESIntensiveGreyOut: boolean;
    public userMaxFailDepStatus: {
        expiryTime?: number;
        blocked?: boolean;
        blockEndDate?: string;
        blockEndTime?: string;
    };
}
export interface PaymentOptionInfo {
    imgPath: string;
    instrumentNumber: string;
    paymentMethod: string;
    paymentText: string;
    sportsOnly: boolean;
    bankAccountsOnly: boolean;
    isESRiskPlayer: boolean;
    ESIntensiveGreyOut: boolean;
    userMaxFailDepStatus: {
        expiryTime?: number;
        blocked?: boolean;
        blockEndDate?: string;
        blockEndTime?: string;
    };
}
export interface SessionInfo {
    [x: string]: string;
    brandId: string;
    channelId: string;
    productId: string;
    LANG_ID: string;
    sessionKey: string;
    userId: string;
    stake: string;
    walletBucketType: string;
    version: string;
    estimatedReturn: string;
    frontend: string;
    hideChat: string;
    bonusCodeForPrefill: string;
}

export interface DataGrid {
    nativeAmountString: string;
    activeItem: false;
    isGridSelected: boolean;
    amountGridIncrementalValue: number;
}

export interface DepositRedirectInfo {
    submitCreq: boolean;
    submitJwt: boolean;
    creq: string;
    redirectionUrl: string;
    openInCustomTab: boolean;
    new_3ds2_route: boolean;
    redirectType: string;
    [key: string]: any;
}
